/* eslint-disable no-console */
import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service';

export const getProductList = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.GET}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductTabsList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.GET}/${data.apiName}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addRangePlanProductInfoService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.ADD_PRODUCTINFO_DATA}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCustomSectionsService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.COMMON_PATH}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomSectionDataService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.CUSTOM_SECTION}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllSectionColumnsService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.GET_SECTION_COLUMNS}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCompanyUsersService = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.COMPANY_USERS}`, {
      params: { CompanyUsers: true },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllCustomAttribute = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CUSTOM_ATTRIBUTE}`, { params: { isActive: true } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchMultiListService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.GET_EXPANDALL}/${data.apiName}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateDataBasedOnXlSXDataService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.EXCEL_SHEET_DATA}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveSupplierDefaultFactoryService = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.UPDATE_SUPPLIER_FACTORY}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMultipleProductCosting = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.MULTIPLE_PRODUCT_COSTING}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const bulkExchangeRateUpdate = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.BULK_UPDATE_EXCHAGNE_RATE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductGroups = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.GET_PRODUCT_GROUP}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const autoSaveCustomSectionService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.AUTOSAVE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const downloadRanplanExcelSheetService = async (data) => {
  try {
    if (data?.tabId === 'costing' && Array.isArray(data?.selectedInfo) && data.selectedInfo.includes('costingInfo')) {
      const userInfo = localStorageService.get('loggedInUserInfo');
      const config = {
        withCredentials: true,
        responseType: 'arraybuffer',
        headers: userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {},
      };
      return await axios.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.DOWNLOAD}`, data, config);
    }
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.DOWNLOAD}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const appendArrayParam = (queryParams, key, arr) => {
  if (Array.isArray(arr) && arr.length > 0) {
    const ids = arr.map((id) => (id != null && typeof id === 'object' && (id._id || id.id) ? id._id || id.id : id)).filter(Boolean);
    if (ids.length) queryParams.append(key, ids.join(','));
  }
};

export const costingExportAllService = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params?.costingTemplateId) queryParams.append('costingTemplateId', params.costingTemplateId);
    if (params?.brandIds?.length) queryParams.append('brandIds', params.brandIds.join(','));
    if (params?.seasonIds?.length) queryParams.append('seasonIds', params.seasonIds.join(','));
    if (params?.supplierIds?.length) queryParams.append('supplierIds', params.supplierIds.join(','));
    if (params?.searchText?.trim()) queryParams.append('searchText', params.searchText.trim());
    if (params?.rangeplanId) queryParams.append('rangeplanId', params.rangeplanId);
    if (params?.timeZone) queryParams.append('timeZone', params.timeZone);
    appendArrayParam(queryParams, 'year', params?.year);
    appendArrayParam(queryParams, 'month', params?.month);
    appendArrayParam(queryParams, 'catOneId', params?.catOneId);
    appendArrayParam(queryParams, 'catTwoId', params?.catTwoId);
    appendArrayParam(queryParams, 'catThreeId', params?.catThreeId);
    appendArrayParam(queryParams, 'catFourId', params?.catFourId);
    appendArrayParam(queryParams, 'statusId', params?.statusId);
    appendArrayParam(queryParams, 'productType', params?.productType);
    appendArrayParam(queryParams, 'createdBy', params?.createdBy);
    appendArrayParam(queryParams, 'COO', params?.COO);
    if (params?.productGroupId) queryParams.append('productGroupId', params.productGroupId);
    appendArrayParam(queryParams, 'subBrandId', params?.subBrandId);
    appendArrayParam(queryParams, 'colorGroupId', params?.colorGroupId);
    appendArrayParam(queryParams, 'colorwayId', params?.colorwayId);
    if (params?.dynamicTypes != null) {
      const raw = params.dynamicTypes;
      queryParams.append('dynamicTypes', typeof raw === 'string' ? raw : JSON.stringify(raw));
    }
    const url = `${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.COSTING_EXPORT_ALL}?${queryParams.toString()}`;
    return await apiClient.get(url, { responseType: 'arraybuffer' });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const costingExportSelectedService = async (params = {}) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.COSTING_EXPORT_SELECTED}`, params, {
      responseType: 'arraybuffer',
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const refreshCostingActionService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.REFRESH_PRODUCT_COSTING}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportRPExcelService = async (data) => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        params: { ...data },
        withCredentials: true,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.DOWNLOAD_RP_SHEETS}`, {}, config)
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/**
 * This function is used to import products in the system by uploading an Excel sheet.
 *
 * @param {Object} data - The data object containing the file to be uploaded and extra parameters to pass to backend.
 * @param {File} data.xls - The Excel file to be uploaded.
 * @param {string} data.tabId - The id of the tab under which the products needs to be uploaded.
 * @param {boolean} data.checked - A boolean indicating whether the products needs to be uploaded with the checked status or not.
 * @returns {Promise} A promise resolving to the response of the API call.
 */
export const importProductsExcelSheet = async (data) => {
  const loginFormData = new FormData();
  loginFormData.append('xls', data.xls);
  loginFormData.append('activeTab', data.activeTab);
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.UPLOAD_FILE}`, loginFormData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const confirmIncludeDuplicatesUpload = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.CONFIRM_UPLOAD}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getRanglePlanLogs = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.GET_RANGEPLAN_LOGS}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getRPProductInformationList = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.GET_PRODUCT_INFORMATION}/${data.apiName}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteRanglePlanLogs = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.GET_RANGEPLAN_LOGS}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const importProductIdentifierExcelSheet = async (data) => {
  const loginFormData = new FormData();
  loginFormData.append('xls', data.xls);
  loginFormData.append('activeTab', data.activeTab);
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.UPLOAD_RP_FILE}`, loginFormData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getRPCustomUploadPresignedUrl = async (fileName, activeTab, sectionId, rangeplanId) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RP_CUSTOM_PRESIGNED_URL}`, {
      fileName,
      activeTab,
      sectionId,
      rangeplanId,
    });
  } catch (error) {
    console.error('getRPCustomUploadPresignedUrl error:', error);
    throw error;
  }
};

export const uploadFileToS3Direct = async (presignedUrl, file) => {
  try {
    const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
    const contentType = fileExtension === '.xlsx' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/vnd.ms-excel';
    const response = await fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': contentType,
      },
    });
    if (response.ok) {
      return { success: true };
    }
    const errorText = await response.text().catch(() => 'No error details');
    console.error('S3 upload failed:', {
      status: response.status,
      statusText: response.statusText,
      error: errorText,
    });
    throw new Error(`Upload failed with status: ${response.status} - ${response.statusText}`);
  } catch (error) {
    console.error('uploadFileToS3Direct error:', error);
    return { success: false, error: error.message };
  }
};

export const getRangePlanCards = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RANGE_PLAN_CARDS.GET_RANGE_PLAN_CARDS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error('Error fetching range plan cards:', error);
    throw error;
  }
};

export const createRangePlanCard = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RANGE_PLAN_CARDS.CREATE_RANGE_PLAN_CARD}`, {
      ...data,
    });
  } catch (error) {
    console.error('Error creating range plan card:', error);
    throw error;
  }
};

export const updateRangePlanCard = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RANGE_PLAN_CARDS.UPDATE_RANGE_PLAN_CARD}`, {
      ...data,
    });
  } catch (error) {
    console.error('Error updating range plan card:', error);
    throw error;
  }
};

export const deleteRangePlanCards = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RANGE_PLAN_CARDS.DELETE_RANGE_PLAN_CARD}`, {
      data: { ...data },
    });
  } catch (error) {
    console.error('Error deleting range plan cards:', error);
    throw error;
  }
};

export const duplicateRangePlanCard = async (data, dupRangeplanId) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RANGE_PLAN_CARDS.DUPLICATE_RANGE_PLAN_CARD}/${dupRangeplanId}`, {
      ...data,
    });
  } catch (error) {
    console.error('Error duplicating range plan card:', error);
    throw error;
  }
};

export const archiveUnarchiveRangePlanCard = async (data) => {
  try {
    const endpoint = data.isArchive
      ? `${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RANGE_PLAN_CARDS.ARCHIVE_RANGE_PLAN_CARD}`
      : `${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RANGE_PLAN_CARDS.UNARCHIVE_RANGE_PLAN_CARD}`;

    const requestData = {
      cardId: data.cardId,
      comment: data.archiveComment,
    };

    return await apiClient.put(endpoint, requestData);
  } catch (error) {
    console.error('Error archiving/unarchiving range plan card:', error);
    throw error;
  }
};

export const archiveUnarchiveRangePlanCards = async (data) => {
  try {
    const endpoint = data.isArchive
      ? `${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RANGE_PLAN_CARDS.ARCHIVE_RANGE_PLAN_CARD}`
      : `${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RANGE_PLAN_CARDS.UNARCHIVE_RANGE_PLAN_CARD}`;

    const requestData = {
      cards: data.cards,
    };

    return await apiClient.put(endpoint, requestData);
  } catch (error) {
    console.error('Error archiving/unarchiving range plan cards:', error);
    throw error;
  }
};

export const pinUnpinRangePlanCard = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RANGE_PLAN_CARDS.PIN_RANGE_PLAN_CARD}`, {
      ...data,
    });
  } catch (error) {
    console.error('Error pinning/unpinning range plan card:', error);
    throw error;
  }
};

export const activeInactiveRangePlanCard = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RANGE_PLAN_CARDS.ACTIVE_INACTIVE_RANGE_PLAN_CARD}`, {
      ...data,
    });
  } catch (error) {
    console.error('Error activating/deactivating range plan card:', error);
    throw error;
  }
};

export const getRangePlanCardDetail = async (cardId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.RANGE_PLAN_CARDS.GET_RANGE_PLAN_CARD_DETAIL}/${cardId}`);
  } catch (error) {
    console.error('Error fetching range plan card detail:', error);
    throw error;
  }
};

export const getColumnTotalsService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.COLUMN_TOTALS}`, {
      ...data,
    });
  } catch (error) {
    console.error('Error fetching column totals:', error);
    throw error;
  }
};
